import { isPlatformBrowser } from '@angular/common';
import {
 ChangeDetectionStrategy,
 Component,
 INJECTOR,
 Inject,
 InjectionToken,
 Injector,
 OnInit,
 Optional,
 PLATFORM_ID,
 WritableSignal,
 computed,
 effect,
 inject,
 signal,
} from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { HomeFlexModel } from '@core/models/domains/home-page-flex';
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar, SwiperOptions } from 'swiper';
import { HomeUiService } from '../home-ui.service';
import { typeCrad } from '../sections/popular-hotels-section/card.model';
import { AuthService } from '@core/services/authentication/auth.service';
import { map, Observable, skipWhile, take, takeUntil, tap } from 'rxjs';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { LoadingService } from '@shared/services/loading.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { fadeAnimation } from '../home-page-wrapper.component';
import { DatepickerService } from '@shared/services/datepicker.service';

export const WINDOW = new InjectionToken<Window>('Window', {
 factory: () => window,
});
// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
@Component({
 selector: 'iho-hotel-wrapper',
 templateUrl: './hotel-wrapper.component.html',
 styleUrls: ['./hotel-wrapper.component.scss'],
 providers: [
  {
   provide: WINDOW,
   useFactory: (platformId: Object) => {
    return isPlatformBrowser(platformId) ? window : {};
   },
   deps: [PLATFORM_ID],
  },
 ],
 animations: [fadeAnimation],

 // changeDetection: ChangeDetectionStrategy.OnPush
})
export class HotelWrapperComponent implements OnInit {
 uiService = inject(HomeUiService);
 route = inject(ActivatedRoute);
 authService = inject(AuthService);
 searchBoxService = inject(SearchBoxService);
 datepickerService = inject(DatepickerService);
 allSections!: HomeFlexModel[];
 allSections$!: Observable<HomeFlexModel[]>;
 accommodation = computed(() => this.searchBoxService.accommodation());
 navigatorVal = true;
 csrStatus = false;
 numberOfRerenderes = 0;
 cdnUrl = cdnUrl;
 mizbanBannerUrl = encodeURI('babolsar-hotels/هتل-ساحلی-میزبان');

 constructor(
  @Inject(WINDOW) private window: Window,
  @Inject(PLATFORM_ID) private platformId: Object,
  private loadingService: LoadingService
 ) {
  // this.allSections = this.route.snapshot.data['sections']

  if (isPlatformBrowser(this.platformId)) {
   this.csrStatus = true;
  }

  this.allSections$ = this.uiService.getAllSections('hotel').pipe(
   map((data) => data.Sections as HomeFlexModel[])
   
  );
 }
 ngOnInit(): void {
 }

 public StateEnum = typeCrad;

 config: SwiperOptions = {
  slidesPerView: 4,
  loop: true,
  grabCursor: true,
  // spaceBetween: 50,

  observer: true, // adding this solve my issue
  //  navigation: {
  //    nextEl: ".ico-Right",
  //    prevEl: ".ico-Left"
  //   },
  pagination: {
   clickable: true,
   // renderBullet:  (index:number, className:string)=> {
   //   return '<span class="' + className + '">' + (index + 1) + '</span>';
   // },
  },
  //scrollbar: { draggable: true },
 };
}
